import script from "./LiveCasinoHome.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveCasinoHome.vue?vue&type=script&setup=true&lang=js"

import "./LiveCasinoHome.vue?vue&type=style&index=0&id=81d285e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81d285e2"]])

export default __exports__